<template>
  <div class="h-full">
    <div class="w-full flex justify-between px-8 p-6 border-b-2 border-zt-dark-200">
      <div class="flex items-center">
        <div class="cursor-pointer mr-4" @click="goToFolderList" data-vs-button="goToFolderList">
          <zt-icon name="arrow-left" />
        </div>
        <zt-icon name="folder" class="text-zt-xl"/>
        <h1 class="ml-4 text-2xl font-bold leading-loose">{{ folderName }}</h1>
      </div>
      <zt-button outlined icon="circle-plus-solid" class="zt-button-h" @click="gotoCreateSubFolder" data-vs-button="gotoCreateSubFolder">
        {{ $t('message.abm.folders.subFolderList.buttonPrimary') }}
      </zt-button>
    </div>
    <list-table
      :folder-list-items="subFolderList"
      :current-page="currentPage"
      :items-per-page="perPage"
      :total-records="total"
      :has-details="false"
      :column-header="columnHeader"
      icon-main="file"
      @paginate-change="updateFoldersTable"
      :loading-rows="isLoading"
    />
  </div>
</template>
<script>
import ListTable from "./table/ListTable";
import {mapActions} from "vuex";
import { forEach, isEmpty, has } from "lodash"
import Folders from '@/apiClient/Folders'
export default {
  name: 'SubFolderList',
  components: { ListTable },
  inject: ['setPagination', 'paginationStore'],
  data() {
    return {
      subFolderList: [],
      columnHeader: [
        {
          title: this.$t('message.abm.folders.subFolderList.header.name'),
          className: 'w-2/5',
          width: ''
        },
        {
          title: this.$t('message.abm.folders.subFolderList.header.documents'),
          className: 'text-center',
          width: '132px'
        },
        {
          title: this.$t('message.abm.folders.subFolderList.header.publish'),
          className: 'text-center',
          width: '132px'
        },
        {
          id: 'signature',
          title: this.$t('message.abm.folders.subFolderList.header.signature'),
          className: 'text-center',
          width: '132px'
        }
      ],
      currentPage: 1,
      perPage:10,
      total: null,
      folderName: this.$route.params.folderName,
      isLoading: false,
      isSignatureActive: false
    }
  },
  methods: {
    ...mapActions({
      getSubFolderList: 'folderSettings/getListSubFoldersAvailable',
    }),
    gotoCreateSubFolder() {
      this.$router.push({ name: 'subFolderCreate' })
    },
    goToFolderList() {
      this.setPagination({
        currentPage: 1,
        perPage: 10,
      })
      this.$router.push('/folder/list')
    },
    async updateFoldersTable(paginate) {
      try {
        this.isLoading = true
        this.subFolderList = []
        const pagination = `${paginate.perPage},${paginate.currentPage},0`
        const list = await this.getSubFolderList({ id: this.$route.params.id, pagination: pagination })
        this.currentPage = paginate.currentPage
        this.perPage = paginate.perPage
        this.total = list.pagination.total
        this.setPagination({
          currentPage: paginate.currentPage,
          perPage: paginate.perPage,
          total: this.total
        })
        forEach(list.data, item => {
          let itemObject = {
            id: item.id,
            name: item.nombre,
            attr1: item.doc_sin_id,
            attr2: item.visible,
            attr3: item.position_signature && has(item.position_signature, 'hasSignatureHolographic')
              ? item.position_signature.hasSignatureHolographic ? 't' : 'f'
              : 'f',
            type: item.tipo,
            toFirstRoute: {
              name: 'subFolderUpdate',
              params: {
                subfolder: item.id
              }
            },
            toSecondRoute: '',
          }
          if (!this.isSignatureActive) itemObject['hidden'] = true
          this.subFolderList.push(itemObject)
        })
        this.$emit('isEmptyList', isEmpty(list), this.folderName)
        this.isLoading = false
      } catch (e) {
        this.$emit('isEmptyList', true, this.folderName)
        this.isLoading = false
      }
    }
  },
  async created() {
    this.currentPage = this.paginationStore.pagination.currentPage
    this.perPage = this.paginationStore.pagination.perPage
    const folderApi = new Folders()
    const {
      data: { data }
    } = await folderApi.getConfigurationFolder(this.$route.params.id)
    this.folderName = data.name
    this.isSignatureActive = data.firmable
    this.columnHeader = this.columnHeader.map(item => {
      if (item.id === 'signature') item['hidden'] = !this.isSignatureActive
      return item
    })
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  & > span > i{
    font-size: 22px;
  }
  .zt-button-text {
    margin-left: 0.68rem !important;
    font-size: 1rem;
  }
  color: #4f41a3 !important;
}
</style>
